export default __webpack_public_path__ + "static/media/원데이 클래스 사진 웹.ea7e1704.jpeg";